import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/wissenswertes",
    name: "wissenswertes",
    // route level code-splitting
    // this generates a separate chunk (wissenswertes.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "wissenswertes" */ "../views/WissenswertesView.vue"),
  },
  {
    path: "/kontakt",
    name: "kontakt",
    // route level code-splitting
    // this generates a separate chunk (contact.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
        import(/* webpackChunkName: "contact" */ "../views/ContactView.vue"),
  },
  {
    path: "/praxis",
    name: "praxis",
    // route level code-splitting
    // this generates a separate chunk (praxis.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
        import(/* webpackChunkName: "praxis" */ "../views/PraxisView.vue"),
  },{
    path: "/leistungen",
    name: "leistungen",
    // route level code-splitting
    // this generates a separate chunk (leistungen.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
        import(/* webpackChunkName: "leistungen" */ "../views/LeistungenView.vue"),
  },{
    path: "/impressum",
    name: "impressum",
    // route level code-splitting
    // this generates a separate chunk (imprint.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
        import(/* webpackChunkName: "imprint" */ "../views/Impressum.vue"),
  },{
    path: "/datenschutz",
    name: "datenschutz",
    // route level code-splitting
    // this generates a separate chunk (privacy.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
        import(/* webpackChunkName: "privacy" */ "../views/Datenschutz.vue"),
  },{
    path: "/karriere",
    name: "karriere",
    // route level code-splitting
    // this generates a separate chunk (career.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
        import(/* webpackChunkName: "career" */ "../views/Career.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
});

export default router;
